<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">{{ type }}</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Guideline -->
    <table
      class="table table-bordered custom-table"
      v-if="type == 'My Staff Leave Utilization Report'"
    >
      <thead class="thead-light">
        <tr>
          <th class="text-center"><h4 class="mb-0">Guideline</h4></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="padding: 0 !important">
            <textarea
              class="form-control"
              rows="10"
              readonly
              v-html="guideline"
            >
            </textarea>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- /Guideline -->

    <!-- Filter -->
    <div class="row mt-2"></div>
    <div
      class="row align-items-center mt-2"
      v-if="type != 'My Leave Utilization Report'"
    >
      <div class="col-md-2">Company</div>
      <div class="col-md-4 pl-md-0">
        <select class="custom-select" v-model="company">
          <option
            v-for="(item, i) in companies"
            :key="i"
            :value="item.CompanyName"
          >
            {{ item.CompanyName }}
          </option>
        </select>
      </div>
    </div>
    <div class="row align-items-center mt-2">
      <div class="col-md-2">Year</div>
      <div class="col-md-4 pl-md-0">
        <select class="custom-select" v-model="year">
          <option v-for="year in years" :key="year" :value="year">
            {{ year }}
          </option>
        </select>
      </div>
    </div>
    <div
      class="row align-items-center mt-2"
      v-if="type != 'My Leave Utilization Report'"
    >
      <div class="col-md-2">Employee Range</div>
      <div class="col-md-4 pl-md-0">
        <Select2 v-model="userId" :options="employees" />
      </div>
      <div class="col-md-1 ml-md-4" style="max-width: fit-content">
        <button class="btn btn-primary" @click="getRecords(null, null)">
          Search
        </button>
      </div>
      <div class="col-md-3">
        <form
          :action="backendUrl + '/LeaveUtilizationExcelReport/ExportExcel'"
          method="POST"
        >
          <input type="hidden" name="Company" :value="company" />
          <input type="hidden" name="Year" :value="year" />
          <input type="hidden" name="UserId" :value="userId" />
          <input type="hidden" name="Type" :value="type" />
          <input type="hidden" name="Token" :value="token" />
          <button type="submit" class="btn btn-primary">
            <img
              width="20px"
              height="20px"
              class="mr-1"
              src="../../assets/excel.png"
            />Export to Excel
          </button>
        </form>
      </div>
    </div>
    <!-- /Filter -->

    <!-- Pagination -->
    <div class="row mt-4" v-if="records && records.length">
      <div class="col-md-6">
        Show
        <select
          class="custom-select"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Result Empty -->
    <div class="mt-4" v-if="records && records.length == 0">
      <div class="col-12 no-record">
        {{ noRecordText }}
      </div>
    </div>
    <!-- /Result Empty -->

    <!-- Table List -->
    <div class="row mt-2" v-if="records && records.length">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th>Employee ID</th>
                <th>Employee Name</th>
                <th>Date Join</th>
                <th>Leave Schemes</th>
                <th>1st Manager ID</th>
                <th>1st Manager Name</th>
                <th>1st Manager Email Address</th>
                <th>Designation</th>
                <th>Functional/Account Team</th>
                <th>Classification</th>
                <th>Job Code</th>
                <th>Annual Leave Carry Forward</th>
                <th>Annual Leave Entitlement</th>
                <th>Annual Leave Total Credit</th>
                <th>Carry Forward Taken (Days deducted from Carry Forward)</th>
                <th>Taken (Days deducted from Entitlement)</th>
                <th>Shutdown Days</th>
                <th>Personal Annual Leave Taken (As of 31 Dec)</th>
                <th>Annual Leave Balance (As of 31 Dec)</th>
                <th>Minimum Days of Annual Leave to Clear (As of 31 Dec)</th>
                <th>Child Care Leave Balance (As of 31 Dec)</th>
                <th>Extended Child Care Leave Balance (As of 31 Dec)</th>
                <th>Family Care Leave Balance (As of 31 Dec)</th>
                <th>Total Leave to Clear by 31 Dec</th>
                <th>Unutilized Off in Lieu Expiring in {{ months[0] }}</th>
                <th>Unutilized Off in Lieu Expiring in {{ months[1] }}</th>
                <th>Unutilized Off in Lieu Expiring in {{ months[2] }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in records" :key="item.Id">
                <td>{{ item.EmployeeID }}</td>
                <td>{{ item.EmployeeName }}</td>
                <td>{{ item.DateJoinDisplay }}</td>
                <td>{{ item.LeaveScheme }}</td>
                <td>{{ item.FirstManagerID }}</td>
                <td>{{ item.FirstManagerName }}</td>
                <td>{{ item.FirstManagerEmail }}</td>
                <td>{{ item.Designation }}</td>
                <td>{{ item.Functional }}</td>
                <td>{{ item.Classification }}</td>
                <td>{{ item.JobCode }}</td>
                <td>{{ item.AnnualLeaveCarryForward }}</td>
                <td>{{ item.AnnualLeaveEntitlement }}</td>
                <td>{{ item.AnnualLeaveTotalCredit }}</td>
                <td>{{ item.CarryForwardTaken }}</td>
                <td>{{ item.Taken }}</td>
                <td>{{ item.ShutdownDays }}</td>
                <td>{{ item.PersonalAnnualLeaveTaken }}</td>
                <td>{{ item.AnnualLeaveBalance }}</td>
                <td>{{ item.MinDaysOfAnnualLeaveToClear }}</td>
                <td>{{ item.ChildCareLeaveBalance }}</td>
                <td>{{ item.ExtendedChildCareLeaveBalance }}</td>
                <td>{{ item.FamilyCareLeaveBalance }}</td>
                <td>{{ item.TotalLeaveToClearBy31Dec }}</td>
                <td>
                  {{ item.UnutilizedOffInLieuExpiringInCurrentMonthPlus1 }}
                </td>
                <td>
                  {{ item.UnutilizedOffInLieuExpiringInCurrentMonthPlus2 }}
                </td>
                <td>
                  {{ item.UnutilizedOffInLieuExpiringInCurrentMonthPlus3 }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="records && records.length">
      <div class="col-md-6 col-lg-6 col-sm-6 my-auto text-lg-left text-center">
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          records.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
import Select2 from "v-select2-component";

export default {
  props: ["type"],
  components: { Select2 },
  data() {
    return {
      records: [],
      noRecordText: config.NO_RECORD_TEXT,
      defaultCompany: config.DEFAULT_COMPANY,
      guideline: "",
      months: [], //for report title
      //filter
      companies: [],
      company: "",
      years: [],
      year: "",
      employees: [],
      userId: "00000000-0000-0000-0000-000000000000",
      //for pagination
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 100,
        Sizes: [5, 10, 20, 100],
      },
      totalRecords: "",
    };
  },
  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
    backendUrl() {
      return this.$backendUrl;
    },
  },
  watch: {
    "paging.SizePerPage": function (val, oldVal) {
      this.paging.CurrentPage = 1;
      this.getRecords(null, null);
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
    company(val) {
      if (this.type != "My Leave Utilization Report") {
        this.userId = "00000000-0000-0000-0000-000000000000";
        this.getEmployeeRange(val);
      }
    },
  },
  methods: {
    //filter
    getCompanies() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getCompanies(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.companies = response.data.record;
            if (
              this.companies.find(
                (c) => c.CompanyName == this.defaultCompany
              ) == null
            ) {
              this.companies.push({ CompanyName: this.defaultCompany });
            }
            this.company = this.defaultCompany;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getYears() {
      let date = new Date();
      let currentYear = date.getFullYear();
      let minYear = currentYear - 2;
      this.years = [];
      for (let year = currentYear; year > minYear; year--) {
        this.years.push(year);
      }
      this.year = currentYear;
    },
    getEmployeeRange(company) {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      let param = {
        Token: this.token,
        ManagerID: data.EmployeeID,
        Company: company ? company : this.company,
      };
      this.$store.state.isLoading = true;
      API.getLeaveUtilizationReportEmployeeRange(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            response.data.record.unshift({
              id: "00000000-0000-0000-0000-000000000000",
              text: "All",
            });
            this.employees = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },

    //records
    getRecords(company, year) {
      let param = {
        Token: this.token,
        CurrentPage: this.paging.CurrentPage,
        TotalPage: this.paging.TotalPage,
        SizePerPage: this.paging.SizePerPage,
        Company: company ? company : this.company,
        Year: year ? year : this.year,
        UserId: this.userId,
        Type: this.type,
      };
      this.$store.state.isLoading = true;
      API.getLeaveUtilizationReport(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.records = response.data.record;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
            this.guideline = response.data.guideline;
            this.months = response.data.months;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getRecords(null, null);
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getRecords(null, null);
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getRecords(null, null);
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getRecords(null, null);
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getRecords(null, null);
    },
  },
  created() {
    this.getCompanies();
    this.getYears();
    this.getEmployeeRange(this.defaultCompany);
    this.getRecords(this.defaultCompany, new Date().getFullYear());
  },
};
</script>

<style scoped>
textarea {
  background-color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/LeaveUtilizationReport/LeaveUtilizationReport.vue